import React from 'react';
import { Box } from '@mui/material';
import { Watermark } from './StyledComponents';
import logo from '../../assets/logo.png';

const AppWatermark = () => {
  return (
    <Watermark component="div">
      <Box sx={{ display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
        <Box
          component="img"
          src={logo}
          alt="Grid & Glory"
          sx={{
            height: '70px',
            width: 'auto',
            filter: 'drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.6))',
          }}
        />
      </Box>
    </Watermark>
  );
};

export default AppWatermark;
